export default `int faceId = int(aPacked.x + 0.5);
vec3 objectNormal = vec3(0.0, 1.0, 0.0);
if (faceId == 0) objectNormal = vec3(1.0, 0.0, 0.0);
else if (faceId == 1) objectNormal = vec3(-1.0, 0.0, 0.0);
else if (faceId == 3) objectNormal = vec3(0.0, -1.0, 0.0);
else if (faceId == 4) objectNormal = vec3(0.0, 0.0, 1.0);
else if (faceId == 5) objectNormal = vec3(0.0, 0.0, -1.0);

vec3 faceNormal = objectNormal;
float farFlat = smoothstep(
    uFlatStart,
    uFlatEnd,
    distance((modelMatrix * vec4(position, 1.0)).xyz, cameraPosition)
);
objectNormal = normalize(mix(objectNormal, vec3(0.0, 1.0, 0.0), farFlat));`